import apiService from "../../../services/api";


export const getPendingApprovalDataJobsList = async (params: {
  limit?: number;
  offset?: number;
} = {}) => {
  const queryParams = new URLSearchParams();
  if (params.limit !== undefined)
    queryParams.append("limit", params.limit.toString());
  if (params.offset !== undefined)
    queryParams.append("offset", params.offset.toString());
  const queryString = queryParams.toString();
  const url = `/platform-approvals/pending${queryString ? `?${queryString}` : ""}`;
  return await apiService.get(url);
};

export const getSuperAdminJobApprovals = async (
  requestId: string,
  payload: { action: "approve" | "reject"; comments?: string }
) => {
  return apiService.post(`/platform-approvals/${requestId}/review`, payload);
};
//api/v1/platform-approvals/{request_id}/review

export const getPlatformApprovalHistory = async (params: {
  status?: string;
  search?: string;
  limit?: number;
  offset?: number;
}) => {
  const queryParams = new URLSearchParams();
  const status = params.status?.trim().toLowerCase();
  const search = params.search?.trim();
  if (status && status !== "all") queryParams.append("status", status);
  if (search) queryParams.append("search", search);
  if (params.limit !== undefined) queryParams.append("limit", String(params.limit));
  if (params.offset !== undefined) queryParams.append("offset", String(params.offset));
  const queryString = queryParams.toString();
  const url = `/platform-approvals/history/all${queryString ? `?${queryString}` : ""}`;
  return apiService.get(url);
};

export const getPlatformApprovalStats = async () => {
  return apiService.get("/platform-approvals/jobs/stats");
};

export const getPlatformApprovalDetails = async (requestId: string) => {
  return apiService.get(`/platform-approvals/${requestId}`);
};
